import { useEffect, useRef } from 'react';
import { Label, Text } from '../../../../../styles/component.styles';

const ProductSlideshowAddSection = ({ onChange }) => {
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!hasInitialized.current) {
      onChange({
        content: {},
        metadata: {
          padding: '2rem 0',
          margin: '2rem auto',
          background: 'transparent',
          align: 'center',
        }
      });
      hasInitialized.current = true;
    }
  }, [onChange]);

  return (
    <>
      <Label>Product Slideshow</Label>
      <Text>
        This section will display a scrollable product slideshow on the shop frontend.
        Products are automatically pulled from active categories with available inventory.
        Styling is not configurable in V1.
      </Text>
    </>
  );
};

export default ProductSlideshowAddSection;